import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

const Comments = ({ newsId }) => {
  const [commentName, setCommentName] = useState("");
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [showAllComments, setShowAllComments] = useState(false);

  const fetchComments = async () => {
    const q = query(
      collection(db, "comments"),
      where("newsId", "==", newsId),
	  orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    setComments(
      snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
    );
  };

  useEffect(() => {
    if (newsId) fetchComments();
  }, [newsId]);

  const submitComment = async () => {
    if (!commentName.trim() || !commentText.trim()) {
      alert("নাম ও মন্তব্য লিখুন");
      return;
    }

    await addDoc(collection(db, "comments"), {
      newsId,
      name: commentName,
      text: commentText,
      createdAt: serverTimestamp(),
    });

    setCommentName("");
    setCommentText("");
    fetchComments();
  };

  return (
    <div
      style={{
        marginTop: "15px",
        borderTop: "1px solid #ddd",
        paddingTop: "15px",
      }}
    >
      <h3
        style={{
          marginBottom: "15px",
          fontSize: "20px",
          color: "#d2202a",
        }}
      >
        💬 মন্তব্য ({comments.length})
      </h3>

      <div
        style={{
          display: "flex",
          gap: "12px",
          alignItems: "flex-start",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="আপনার নাম"
          value={commentName}
          onChange={(e) => setCommentName(e.target.value)}
          style={{
            width: "150px",
            height: "45px",
            padding: "0 10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
            boxSizing: "border-box",
          }}
        />

        <div
          style={{
            position: "relative",
            flex: 1,
          }}
        >
          <textarea
            placeholder="এখানে আপনার মন্তব্য লিখুন..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            style={{
              width: "100%",
              height: "40px",
              padding: "10px 100px 10px 10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              resize: "none",
              fontSize: "14px",
              boxSizing: "border-box",
            }}
          />

          <button
            onClick={submitComment}
            style={{
              position: "absolute",
              right: "0",
              top: "0",
              height: "40px",
              padding: "0 18px",
              border: "none",
              borderRadius: "0 6px 6px 0",
              background: "#d2202a",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            সাবমিট
          </button>
        </div>
      </div>

      {comments.length === 0 ? (
        <div style={{ color: "#777", padding: "10px 0" }}>
          এখনো কোনো মন্তব্য করা হয়নি।
        </div>
      ) : (
        <>
          {(showAllComments ? comments : comments.slice(0, 3)).map((c) => (
            <div
              key={c.id}
              style={{
                padding: "14px 0",
                borderBottom: "1px solid #eee",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: "6px",
                }}
              >
                {c.name}
              </div>

              <div
                style={{
                  lineHeight: "1.7",
                }}
              >
                {c.text}
              </div>
            </div>
          ))}

          {comments.length > 3 && (
            <div
              onClick={() => setShowAllComments(!showAllComments)}
              style={{
                marginTop: "15px",
                textAlign: "center",
                color: "#d2202a",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {showAllComments
                ? "▲ মন্তব্য Hide করুন"
                : `▼ আরও ${comments.length - 3}টি মন্তব্য দেখুন`}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Comments;